let navigateFn = null;

export const setNavigate = (navigate) => {
  navigateFn = navigate;
};

export const navigate = (...args) => {
  if (!navigateFn) {
    console.warn("navigate() called before navigation is set");
    return;
  }
  return navigateFn(...args);
};
